<template>
  <div class="page-signup">
    <img src="@/assets/images/logotype.png" alt="RFF Logotype" class="d-none d-md-block logo position-absolute">
    <SignUpForm :reservedUser="reservedUser" :isNewUser="isNewUser" :token="$route.params.token" :md5="$route.params.email" @signed="login" />
  </div>
</template>

<script>

import validateMixin from '../../../libs/Form/mixins/validate';
import $api from '../../../libs/Api/services/api';
import $localStorage from '../../../libs/Storage/services/localStorage';
import $oauth2 from '../../../libs/OAuth2/services/auth';

export default {
  name: 'page-activation-landing',
  mixins: [validateMixin],
  components: {
    SignUpForm: () => import('../../components/Form/SignupForm'),
  },
  data () {
    return {
      reservedUser: null,
      isNewUser: true,
      alert: {
        status: null,
        message: null,
      },
      privacy: false,
    };
  },
  mounted () {
    if (!this.isNewUser) {
      this.$emit('title', 'Registrati');
    } else {
      this.$emit('title', 'Accetta invito');
    }
  },
  methods: {
    login (user) {
      this.$oauth2
        .loginWithCredentials(user.email, user.password)
        .then(() => {
          return this.$router.push({ name: 'root' });
        })
        .catch(() => {
          return this.$router.push({ name: 'login' });
        })
      ;
    },
  },
  beforeRouteEnter: async (to, from, next) => {
    $localStorage.delete('signup-email');
    $localStorage.delete('signup-token');

    let reservedUser;
    let status;

    try {
      const request = await $api.getUserReservation(to.params.email, to.params.token);
      reservedUser = request.data;
      status = request.status;
    } catch (err) {
      const { data } = err.response;
      status = err.response.status;

      if (status === 404) {
        return next({ name: 'login', replace: true });
      }

      if (status === 410) {
        $localStorage.put('signup-email', to.params.email);
        $localStorage.put('signup-token', to.params.token);
        reservedUser = data || false;
      }
    }

    if (reservedUser) {
      if ($oauth2.me && reservedUser.email !== $oauth2.me) {
        await $oauth2.logout();
      }

      return next(vm => {
        vm.reservedUser = reservedUser;
        vm.isNewUser = status === 200;
      });
    }

    return next({ name: 'login', replace: true });
  },
};

</script>

<style lang="scss">

.page-signup {
  .logo {
    animation-delay: 1.5s;
    animation-duration: .7s;
    animation-fill-mode: both;
    animation-iteration-count: 1;
    animation-name: translateLogo;
    animation-timing-function: ease-out;
    right: 0;
    top: 0;
    transform: translate(0, 0);
    width: 100px;
  }

  @keyframes translateLogo {
    from {
      opacity: 0;
      padding: 20px;
      transform: translate(0, 0);
    }

    to {
      opacity: 1;
      padding: 0;
      transform: translate(50%, -50%);
    }
  }

  &--message {
    padding-left: 15%;
    margin-right: 15%;
  }
}

</style>
